<template>
<!--  <v-menu-->
<!--      ref='isOpen'-->
<!--      v-model='isOpen'-->
<!--      :close-on-content-click='false'-->
<!--      transition='scale-transition'-->
<!--      :disabled='!vInput.isEdit'-->
<!--      offset-y-->
<!--      min-width='290px'-->
<!--  >-->
<!--    <template v-slot:activator='{ on, attrs }'>-->
<!--      <v-text-field-->
<!--          v-model='tmpDate'-->
<!--          :label='keys.attrs.label'-->
<!--          append-icon='mdi-calendar-month'-->
<!--          :disabled='!vInput.isEdit'-->
<!--          :outlined='keys.attrs.outlined'-->
<!--          v-bind='{...attrs,...attr}'-->
<!--          v-on='on'-->
<!--      ></v-text-field>-->
<!--    </template>-->
        <v-text-field
            class='date'
            :label='keys.attrs.label'
            type='date'
            v-model='date'
            :readonly='!!keys.attrs.readonly'
            :disabled='!vInput.isEdit'
            outlined
            dense
        />
<!--    <v-date-picker-->
<!--        :readonly='!!keys.attrs.readonly'-->
<!--        v-model='date'-->
<!--        no-title-->
<!--        @input='isOpen = false'-->
<!--    ></v-date-picker>-->
<!--  </v-menu>-->
</template>
<script>
export default {
  props: {
    itemKey: String,
    item: Object,
    keys: Object,
    vInput: Object,
    attr: Object
  },
  data: () => ({
    object: {},
    isOpen: false,
    date: '',
    tmpDate: new Date().toISOString().substr(0, 10)
  }),
  created() {
    if (this.item) {
      this.object = this.item
      const date = this.object[this.itemKey]?.substr(0, 10)
      this.date = !isNaN(Date.parse(date)) ? date : this.tmpDate
    }
  },
  computed: {},
  watch: {
    date(date) {
      this.object[this.itemKey] = date
      const tmp = date.toString().split('-')
      this.tmpDate = `${tmp[2]}/${tmp[1]}/${tmp[0]}`
    }
  }
}
</script>
